<div class="business-activities-dialog" [attr.dir]="dir">
    <h2 mat-dialog-title class="text-2xl font-bold mb-4">{{ 'select_business_activities' | translate }}</h2>
    
    <mat-dialog-content class="activities-content">
        <div class="search-box mb-4">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'search_activities' | translate }}</mat-label>
                <input matInput 
                       [(ngModel)]="searchText" 
                       (input)="filterActivities()" 
                       [placeholder]="'search_by_name_or_description' | translate"
                       autocomplete="off">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        
        <!-- Loading state -->
        <div class="loading-activities" *ngIf="isLoading">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="text-gray-600 mt-4">{{ 'loading' | translate }}...</p>
        </div>
        
        <div class="activities-grid" *ngIf="!isLoading && filteredActivities && filteredActivities.length > 0">
            <div *ngFor="let activity of filteredActivities" 
                 class="activity-card" 
                 [class.selected]="isActivitySelected(activity._id)"
                 (click)="toggleActivity(activity)">
                <div class="activity-card-content">
                    <div class="activity-icon" *ngIf="activity.icon">
                        <img [src]="activity.icon" 
                             [alt]="translateHelper.localize(activity.name)"
                             (error)="onIconError($event)"
                             onerror="this.style.display='none'">
                    </div>
                    <div class="activity-icon fallback-icon" *ngIf="!activity.icon">
                        <mat-icon>business_center</mat-icon>
                    </div>
                    <div class="activity-details">
                        <h3 class="activity-name">{{ translateHelper.localize(activity.name) }}</h3>
                        <p class="activity-description" *ngIf="activity.description">
                            {{ translateHelper.localize(activity.description) }}
                        </p>
                        <div class="activity-categories-count" *ngIf="activity.categories && activity.categories.length > 0">
                            <mat-icon class="text-sm">category</mat-icon>
                            <span>{{ activity.categories.length }} {{ 'categories' | translate }}</span>
                        </div>
                    </div>
                    <div class="activity-checkbox">
                        <mat-icon *ngIf="isActivitySelected(activity._id)" class="check-icon">check_circle</mat-icon>
                        <mat-icon *ngIf="!isActivitySelected(activity._id)" class="check-icon-outline">radio_button_unchecked</mat-icon>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="no-activities" *ngIf="!isLoading && (!filteredActivities || filteredActivities.length === 0)">
            <mat-icon class="text-gray-400 text-5xl">business_center</mat-icon>
            <p class="text-gray-600 mt-4">{{ 'no_activities_found' | translate }}</p>
        </div>
    </mat-dialog-content>
    
    <mat-dialog-actions class="dialog-actions">
        <div class="selected-count">
            <span *ngIf="selectedActivities.length > 0">
                {{ selectedActivities.length }} {{ 'activities_selected' | translate }}
            </span>
        </div>
        <div class="action-buttons">
            <button mat-button (click)="close()">{{ 'cancel' | translate }}</button>
            <button mat-raised-button style="background-color: #3b82f6 !important; color: white !important;" (click)="saveSelection()" [disabled]="selectedActivities.length === 0">
                {{ 'confirm' | translate }}
            </button>
        </div>
    </mat-dialog-actions>
</div>
